import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { authService } from '../../services/api';
import './Auth.css';

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email inválido')
    .required('Email es obligatorio')
});

const ForgotPassword = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await authService.forgotPassword(values.email);
      setSubmitted(true);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al procesar la solicitud');
    } finally {
      setSubmitting(false);
    }
  };
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Recuperar contraseña</h2>
        
        {submitted ? (
          <div className="text-center">
            <div className="alert alert-success" role="alert">
              Si hay una cuenta asociada a este correo, recibirás instrucciones para restablecer tu contraseña.
            </div>
            <Link to="/login" className="btn btn-primary mt-3">
              Volver al inicio de sesión
            </Link>
          </div>
        ) : (
          <>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            
            <p className="mb-4">
              Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
            </p>
            
            <Formik
              initialValues={{ email: '' }}
              validationSchema={ForgotPasswordSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, errors, touched }) => (
                <Form>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <Field
                      type="email"
                      name="email"
                      className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                    />
                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                  </div>
                  
                  <button 
                    type="submit" 
                    className="btn btn-primary w-100" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar enlace de recuperación'}
                  </button>
                </Form>
              )}
            </Formik>
            
            <div className="mt-3 text-center">
              <Link to="/login">Volver al inicio de sesión</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
